import { NgModule } from '@angular/core';
import { UserAccountService } from './user-account.service';

@NgModule({
  declarations: [],
  imports: [],
  providers: [UserAccountService],
})
export class UserAccountModule {}
